import { render, staticRenderFns } from "./addStock.vue?vue&type=template&id=d45bc8d6&scoped=true&"
import script from "./addStock.vue?vue&type=script&lang=js&"
export * from "./addStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45bc8d6",
  null
  
)

export default component.exports